import {getRequest} from './api'
import {Message} from 'element-ui'

export const isNotNullORBlank = (...args)=> {
  for (var i = 0; i < args.length; i++) {
    var argument = args[i];
    if (argument == null || argument === '' || argument === undefined) {
      Message.warning({message: '数据不能为空!'});
      return false;
    }
  }
  return true;
}
export const initMenu = (router, store)=> {
  if (store.state.routes.length > 0) {
    return;
  }
  // 获取系统菜单
  getRequest("/admin/api/sys/sysmenu").then(resp=> {
    if (resp && resp.code  === 0) {
      var fmtRoutes = formatRoutes(resp.data);
      router.addRoutes(fmtRoutes);
      store.commit('initMenu', fmtRoutes);
      // store.dispatch('connect');
    }
  })
}
export const formatRoutes = (routes)=> {
  let fmRoutes = [];
  routes.forEach(router=> {
    let {
      path,
      component,
      name,
      iconCls,
      children
    } = router;
    if (children && children instanceof Array) {
      children = formatRoutes(children);
    }
    let fmRouter = {
      path: path,
      component(resolve){
        if (component.startsWith("Home")) {
          require(['../components/' + component + '.vue'], resolve)
        } else if (component.startsWith("Sys")) {
          require(['../components/system/' + component + '.vue'], resolve)
        }else if (component.startsWith("Taxonomy")) {
          require(['../components/taxonomy/' + component + '.vue'], resolve)
        }else if (component.startsWith("News")) {
          require(['../components/news/' + component + '.vue'], resolve)
        }else if (component.startsWith("Article")) {
          require(['../components/article/' + component + '.vue'], resolve)
        }else if (component.startsWith("Web")) {
          require(['../components/web/' + component + '.vue'], resolve)
        }else if (component.startsWith("Share")) {
          require(['../components/share/' + component + '.vue'], resolve)
        }else if (component.startsWith("Identify")) {
          require(['../components/identify/' + component + '.vue'], resolve)
        }else if (component.startsWith("Database")) {
          require(['../components/database/' + component + '.vue'], resolve)
        }else if (component.startsWith("ITaxalgae")) {
          require(['../components/iTaxalgae/' + component + '.vue'], resolve)
        }else if (component.startsWith("Templete")) {
          require(['../components/templete/' + component + '.vue'], resolve)
        }else if (component.startsWith("Manage")) {
          require(['../components/manage/' + component + '.vue'], resolve)
        }else if (component.startsWith("Detect")) {
          require(['../components/detect/' + component + '.vue'], resolve)
        }
      },
      name: name,
      iconCls: iconCls,
      children: children
    };
    fmRoutes.push(fmRouter);
  })
  return fmRoutes;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js